import React from "react";
import {
  Box,
  Table,
  Thead,
  Tr,
  Th,
  Td,
  Tbody,
  Button,
  Text,
} from "@chakra-ui/react";
export const OneTimePlan = ({ oneTimePlans, onEdit }) => {
  
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-end",
      }}
    >
      <Table>
        <Thead>
          <Tr>
            <Th>Price</Th>
            <Th>Currency</Th>
            <Th>Action</Th>
          </Tr>
        </Thead>
        <Tbody>
          {oneTimePlans.map(
            ({
              id,
              price,
              currency,
            }) => (
              <Tr key={id}>
                <Td fontWeight="600" color="blue.500">{price}</Td>
                <Td>{currency}</Td>
                <Td>
                  <Button
                    colorScheme="blue"
                    fontWeight="600"
                    variant="outline"
                    onClick={() => onEdit(id)}
                    width="50%"
                  >
                    Edit
                  </Button>
                </Td>
              </Tr>
            )
          )}
        </Tbody>
      </Table>
      {oneTimePlans.length === 0 && (
        <Text width="100%" textAlign="center" fontSize="lg" padding="10px 0">
          No plans are there. Add new plans.
        </Text>
      )}
    </Box>
  );
};
